import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';

import { Router } from './routes';
import { getConfig } from './service/api';

const App: React.FunctionComponent = () => {
  const [config, setConfig] = useState({ ad: '', exp: '' });

  const urlParams = new URLSearchParams(window.location.search);
  const crowdin = urlParams.get('crowdin');

  const onMount = async () => {
    const config = await getConfig();
    setConfig(config);
  };

  useEffect(() => {
    onMount();
  }, []);

  return (
    <>
      {crowdin === 'edit' && (
        <Helmet>
          <script type="text/javascript">
            var _jipt = []; _jipt.push(['project', 'gjensidigebuilders']);
          </script>
          <script
            type="text/javascript"
            src="//cdn.crowdin.com/jipt/jipt.js"
          ></script>
        </Helmet>
      )}
      <Router config={config} />
    </>
  );
};

export default App;
